import React from "react";

function CompliedSvgComponent(props: any) {
  return (
    <div>
      <svg
        id="assignment_turned_in_black_24dp"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          id="Path_40252"
          data-name="Path 40252"
          d="M0,0H24V24H0Z"
          fill="none"
        />
        <path
          id="Path_40253"
          data-name="Path 40253"
          d="M18,9,16.59,7.58,10,14.17,7.41,11.59,6,13l4,4Zm1-6H14.82A2.988,2.988,0,0,0,9.18,3H5a1.752,1.752,0,0,0-.4.04A2.021,2.021,0,0,0,3.16,4.23,1.926,1.926,0,0,0,3,5V19a2.052,2.052,0,0,0,.16.78,2.119,2.119,0,0,0,.43.64,2.008,2.008,0,0,0,1.01.55A2.6,2.6,0,0,0,5,21H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm-7-.25a.75.75,0,1,1-.75.75A.755.755,0,0,1,12,2.75ZM19,19H5V5H19Z"
          fill="#49a05f"
        />
      </svg>
    </div>
  );
}

export default CompliedSvgComponent;
